import * as React from "react";

// Top-view tree - circular canopy with branches radiating from trunk
function TreeIcon({ color = "#2E7D32", width = 40, height = 40, name }) {
  return (
    <div style={{ textAlign: "center" }}>
      {name && <p style={{ margin: 0, fontSize: "10px", userSelect: "none" }}>{name}</p>}
      <svg
        viewBox="0 0 100 100"
        height={height}
        width={width}
      >
        {/* Tree canopy - multiple overlapping circles for natural look */}
        <circle cx="50" cy="50" r="45" fill={color} opacity="0.7" />
        <circle cx="35" cy="35" r="25" fill={color} opacity="0.8" />
        <circle cx="65" cy="35" r="25" fill={color} opacity="0.8" />
        <circle cx="35" cy="65" r="25" fill={color} opacity="0.8" />
        <circle cx="65" cy="65" r="25" fill={color} opacity="0.8" />
        <circle cx="50" cy="30" r="20" fill={color} opacity="0.9" />
        <circle cx="30" cy="50" r="20" fill={color} opacity="0.9" />
        <circle cx="70" cy="50" r="20" fill={color} opacity="0.9" />
        <circle cx="50" cy="70" r="20" fill={color} opacity="0.9" />
        {/* Trunk center */}
        <circle cx="50" cy="50" r="8" fill="#5D4037" />
        <circle cx="50" cy="50" r="5" fill="#4E342E" />
      </svg>
    </div>
  );
}

export default TreeIcon;
